import { useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { YellowButton } from "../../components/UI/Button/button";
import {
  TERMSOFSERVICE,
  TERMSTABLEOFCONTENT,
  TERMS_OF_SERVICE_META,
} from "../../constants";
import classes from "./TermsAndPolicy.module.css";
import DOMPurify from "dompurify";
const TermsOfService = () => {
  const ref = useRef([]);
  let navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const renderList = (list, keyPrefix) => {
    if (!list || list.length === 0) return null;

    return (
      <ul>
        {list.map((item, index) => (
          <li
            key={`${keyPrefix}-${index}`}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(item),
            }}
          />
        ))}
      </ul>
    );
  };

  const renderSubsection = (subsection, keyPrefix, depth = 0) => {
    if (!subsection) return null;

    return (
      <div style={{ marginTop: depth === 0 ? "20px" : "10px" }}>
        {subsection.heading && (
          <h4 className="mb-sm font-medium mt-6">{subsection.heading}</h4>
        )}
        {subsection.message && (
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(subsection.message),
            }}
          />
        )}
        {renderList(subsection.list, `${keyPrefix}-list`)}
        {subsection.additional && (
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(subsection.additional),
            }}
            className="mt-3"
          />
        )}
        {subsection.subsections &&
          subsection.subsections.map((nested, nestedIndex) => (
            <div key={`${keyPrefix}-nested-${nestedIndex}`}>
              {renderSubsection(
                nested,
                `${keyPrefix}-nested-${nestedIndex}`,
                depth + 1
              )}
            </div>
          ))}
      </div>
    );
  };

  return (
    <div className={`mt-md ${classes.terms}`}>
      <h3>Last Revised: {TERMS_OF_SERVICE_META.lastUpdated}</h3>
      <h3 className="mt-md mb-md">TABLE OF CONTENTS</h3>
      {TERMSTABLEOFCONTENT.map((content, index) => (
        <button
          key={`content-${index}`}
          className={`${classes.content}`}
          onClick={() =>
            ref.current[index].scrollIntoView({ behavior: "smooth" })
          }
        >
          {+index + 1}. {content}
        </button>
      ))}
      <ol>
        {TERMSOFSERVICE.map((section, index) => (
          <li
            key={`mapped-terms-${index}`}
            ref={(el) => (ref.current[index] = el)}
          >
            <h3 className="mt-bg mb-md">
              {+index + 1}. {section.title}
            </h3>

            {section.message && (
              <p
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(section.message),
                }}
              />
            )}

            {renderList(section.list, `main-list-${index}`)}

            {section.additional && (
              <p
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(section.additional),
                }}
                className="mt-3"
              />
            )}

            {section.subsection &&
              renderSubsection(section.subsection, `subsection-${index}`)}

            {section.subsections && section.subsections.length > 0 && (
              <div>
                {section.subsections.map((subsection, subIndex) => (
                  <div key={`subsections-${index}-${subIndex}`}>
                    {renderSubsection(
                      subsection,
                      `subsections-${index}-${subIndex}`,
                      subIndex
                    )}
                  </div>
                ))}
              </div>
            )}
          </li>
        ))}
      </ol>

      <div className={`center-flex mb-bg mt-bg ${classes.btn}`}>
        <YellowButton onClick={() => navigate(-1)}>Go Back</YellowButton>
      </div>
    </div>
  );
};

export default TermsOfService;
